import axios from "axios";
import Vue from "vue";
import { Loading } from 'element-ui';
let baseURL = process.env.VUE_APP_BaseUrl
const request = axios.create({
    baseURL
})
let options = {
    text:'数据加载中',
    background:'rgba(255,255,255,0)',
    spinner:'el-icon-loading'
}
request.interceptors.request.use(config => {
    config.headers = {
        'X-Access-Token':localStorage.token || ''
    }
    Loading.service(options);
    let loadingInstanceing = Loading.service(options);
 setTimeout(()=>{
    loadingInstanceing.close();
 },1000)
    return config
})
request.interceptors.response.use(function (response){
    if(response.data.code == 500){
        Vue.prototype.$message.error(response.data.message)
        return Promise.reject(response.data.message)
    }
    if(response.data.code == 400){
        Vue.prototype.$router.push({
            name:'login'
        })
    }
    let loadingInstance = Loading.service(options);
    Vue.prototype.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close();
    });
    return response
},function (error){
    console.log('执行关闭')
    let loadingInstance = Loading.service(options);
    setTimeout(()=>{
        loadingInstance.close();
     },1000)
    return Promise.reject(error)
})
export default request
